import useSWR from 'swr';
/**
 *
 * @param {*} entitiesIds | Array with the entities, example ['Events','OnlineShowRoom']
 */

var useLabelsFromAPI = function useLabelsFromAPI(entitiesIds) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
  var active = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  /**
   * Fetches the data from the api
   * We only want Labels types, and also only the entities specified separated by comma
   */
  var _useSWR = useSWR(active && "/msvc/v1/translations/values/Label/".concat(entitiesIds.join(','), "/allFields/").concat(language), {
    revalidateOnFocus: false
  }),
      data = _useSWR.data;

  return {
    labels: data && data.Label,

    /**
     * Can also be used to access labels and implements a fallback in case the label is not set or does not exist
     * @param {string} entityId
     * @param {string} fieldName
     * @returns {*|string}
     */
    t: function t(entityId, fieldName) {
      return data && data.Label[entityId] && data.Label[entityId][fieldName] ? data.Label[entityId][fieldName] : "##".concat(entityId, ".").concat(fieldName, "##");
    }
  };
};

export default useLabelsFromAPI;